import axios from 'axios'

const apiUrl = 'https://sitebypro-server.ru/druzbamebel'

function apiError(error, fallback) {
  return error && error.response && error.response.data && error.response.data.data && error.response.data.data.text
    ? error.response.data.data.text
    : error && error.message ? error.message : fallback
}

export default {
  state: {
    shippingQuotes: [],
    shippingQuoteErrors: {},
    shippingQuoteLoading: false,
    shippingConfig: {}
  },
  getters: {
    shippingQuotes: state => state.shippingQuotes,
    shippingQuoteErrors: state => state.shippingQuoteErrors,
    shippingQuoteLoading: state => state.shippingQuoteLoading,
    shippingConfig: state => state.shippingConfig
  },
  mutations: {
    SET_SHIPPING_QUOTES(state, payload) {
      state.shippingQuotes = Array.isArray(payload && payload.quotes) ? payload.quotes : []
      state.shippingQuoteErrors = payload && payload.errors && typeof payload.errors === 'object' ? payload.errors : {}
    },
    SET_SHIPPING_QUOTE_LOADING(state, value) {
      state.shippingQuoteLoading = Boolean(value)
    },
    SET_SHIPPING_CONFIG(state, value) {
      state.shippingConfig = value && typeof value === 'object' ? value : {}
    },
    RESET_SHIPPING_QUOTES(state) {
      state.shippingQuotes = []
      state.shippingQuoteErrors = {}
      state.shippingQuoteLoading = false
    }
  },
  actions: {
    async GET_SHIPPING_CONFIG({ commit }) {
      try {
        const response = await axios.get(`${apiUrl}/shipping/config`)
        const payload = response && response.data && response.data.data || {}
        commit('SET_SHIPPING_CONFIG', payload)
        return payload
      } catch (error) {
        return {}
      }
    },
    async GET_SHIPPING_QUOTES({ commit }, data) {
      commit('SET_SHIPPING_QUOTE_LOADING', true)
      try {
        const response = await axios.post(`${apiUrl}/shipping/quote`, data)
        const result = response && response.data || {}
        if (String(result.status) !== '200') throw new Error(result.data && result.data.text || 'Не удалось рассчитать доставку')
        commit('SET_SHIPPING_QUOTES', result.data || {})
        return result.data || {}
      } catch (error) {
        const message = apiError(error, 'Не удалось рассчитать доставку')
        commit('SET_SHIPPING_QUOTES', { quotes: [], errors: { general: message } })
        return { quotes: [], errors: { general: message } }
      } finally {
        commit('SET_SHIPPING_QUOTE_LOADING', false)
      }
    }
  }
}
